<template>
  <div class="knowledge-repo-page">
    <title-bar title="知识库">
      <el-input placeholder="搜索知识问答" v-model="query.title">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </title-bar>

    <div class="main">
      <div
        class="exam-overview-card"
        @click="navToExamDetail(exam)"
        v-for="(exam, index) in filterExamList"
        :key="index"
      >
        <img src="./assets/img_knowledge_poster@2x.png" />
        <div class="title">{{ exam.title }}</div>
        <div class="author">{{ exam.author }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import { IPaperItem } from 'kuaidong-model'
import { AWinter2023 } from 'kuaidong-api'
@Component({
  components: {
    TitleBar,
  },
})
export default class KnowledgeRepoPage extends BasePage {
  query = {
    title: '',
  }

  knowledgeRepoList: IPaperItem[] = []
  get filterExamList() {
    if (this.query.title) {
      return this.knowledgeRepoList.filter((item) => {
        return item.title.includes(this.query.title)
      })
    } else {
      return this.knowledgeRepoList
    }
  }

  async created() {
    this.fetchKnowledgeRepoList()
  }

  async fetchKnowledgeRepoList() {
    this.knowledgeRepoList = await AWinter2023.paperList()
  }

  navToExamDetail(exam: IPaperItem) {
    this.$router.push({
      name: 'pe_knowledge_exam_detail',
      query: {
        id: exam.paper_id,
      },
    })
  }
}
</script>
<style lang="less">
.knowledge-repo-page {
  > .main {
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    > .exam-overview-card {
      margin-right: 23px;
      margin-bottom: 30px;
      box-sizing: border-box;
      &:hover {
        cursor: pointer;
      }
      > img {
        width: 243px;
        height: 138px;
      }
      > .title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #2d2f33;
        width: 240px;
      }

      > .author {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #8f8f8f;
        margin-top: 12px;
      }
    }
  }
}
</style>
